
import debounce from "lodash/debounce";

import { startFetching, stopFetching } from "./ActionProcessing";
import WssService from "../services/WssService";
import { searchToObject } from "../utils/index";
import { sendCountingCWarsAttempts } from "../web2ClientAPI/base";
import get from "lodash/get";
import axios from "axios";


export type CWARS_UPDATE_COMMON_INFO_TYPE = "CWARS_UPDATE_COMMON_INFO";
export type CWARS_UPDATE_STAGES_TYPE = "CWARS_UPDATE_STAGES";
export type CWARS_UPDATE_SETTINGS_TYPE = "CWARS_UPDATE_SETTINGS";
export type CWARS_UPDATE_RATINGS_TYPE = "CWARS_UPDATE_RATINGS";
export type CWARS_UPDATE_RATINGS_SEARCH_TYPE = "CWARS_UPDATE_RATINGS_SEARCH";
export type CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE_TYPE = "CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE";
export type CWARS_UPDATE_LAST_ROUND_RESULTS_TYPE = "CWARS_UPDATE_LAST_ROUND_RESULTS";
export type CWARS_UPDATE_ROUNDS_RESULTS_HISTORY_TYPE = "CWARS_UPDATE_ROUNDS_RESULTS_HISTORY";

export type WSS_ACTIONS_TYPE = {
  CWARS_UPDATE_COMMON_INFO: CWARS_UPDATE_COMMON_INFO_TYPE;
  CWARS_UPDATE_STAGES: CWARS_UPDATE_STAGES_TYPE;
  CWARS_UPDATE_SETTINGS: CWARS_UPDATE_SETTINGS_TYPE;
  CWARS_UPDATE_RATINGS: CWARS_UPDATE_RATINGS_TYPE;
  CWARS_UPDATE_RATINGS_SEARCH: CWARS_UPDATE_RATINGS_SEARCH_TYPE;
  CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE: CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE_TYPE;
  CWARS_UPDATE_LAST_ROUND_RESULTS: CWARS_UPDATE_LAST_ROUND_RESULTS_TYPE;
  CWARS_UPDATE_ROUNDS_RESULTS_HISTORY: CWARS_UPDATE_ROUNDS_RESULTS_HISTORY_TYPE;
};

export const WSS_ACTIONS: WSS_ACTIONS_TYPE = {
  CWARS_UPDATE_COMMON_INFO: 'CWARS_UPDATE_COMMON_INFO',
  CWARS_UPDATE_STAGES: 'CWARS_UPDATE_STAGES',
  CWARS_UPDATE_SETTINGS: 'CWARS_UPDATE_SETTINGS',
  CWARS_UPDATE_RATINGS: 'CWARS_UPDATE_RATINGS',
  CWARS_UPDATE_RATINGS_SEARCH: 'CWARS_UPDATE_RATINGS_SEARCH',
  CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE: 'CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE',
  CWARS_UPDATE_LAST_ROUND_RESULTS: 'CWARS_UPDATE_LAST_ROUND_RESULTS',
  CWARS_UPDATE_ROUNDS_RESULTS_HISTORY: 'CWARS_UPDATE_ROUNDS_RESULTS_HISTORY'
};

export type INIT_TYPE = "INIT";
export const INIT: INIT_TYPE = 'INIT';
export const init = (isReload: boolean) => (dispatch: Dispatch, getState: GetState) => {

  const state = getState();

  dispatch(checkReady());

  dispatch({
    type: INIT
  });

  dispatch(getShips());

  dispatch(checkFromParam());

  const onMessage = e => {
    const data = JSON.parse(e.data);
    dispatch(setWssData(data.actionType, data.payload));
    console.log(data.actionType, data.payload);

    if (data.actionType === WSS_ACTIONS.CWARS_UPDATE_STAGES && (data.payload.currentStage === 'preparation' || data.payload.currentStage === 'lull')) {
      WssService.getCommonInfo();
      WssService.getLastRoundResults(state.currentAccount.clanId);
    }
  };

  const onError = err => {
    console.log(`*** ERROR ${err.request.actionType} ***`, err);
    dispatch(stopFetching());
    dispatch(setError(err));
  };

  const onOpen = () => {
    dispatch(setOnline());
    WssService.getInitData();
  };

  const onClose = () => {
    dispatch(setOffline());
  };

  const onFailConnection = () => {
    dispatch(stopFetching());
    dispatch(setError(new Error()));
  };

  WssService.init({
    onMessage: onMessage,
    onOpen: onOpen,
    onClose: onClose,
    onError: onError,
    onFailConnection: onFailConnection,
    url: state.urls.ws
  });

  if (!state.ReducerClanWars.isReady) {
    dispatch(startFetching());
  }

  if (isReload) {
    WssService.getInitData();
  }
};


export type GET_SHIPS_TYPE = "GET_SHIPS";
export const GET_SHIPS: GET_SHIPS_TYPE = 'GET_SHIPS';
export const getShips = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  if (state.urls.vehiclesInfo) {
    axios.get(state.urls.vehiclesInfo).then(resp => {
      dispatch({
        type: GET_SHIPS,
        payload: {
          ships: resp.data
        }
      });
    }).catch(err => {
      console.error(err);
    });
  } else {
    console.error('no vehiclesInfo url');
  }
};


export type SET_ERROR_TYPE = "SET_ERROR";
export const SET_ERROR: SET_ERROR_TYPE = 'SET_ERROR';
export const setError = (err: any) => (dispatch: Dispatch, getState: GetState) => {
  if (err.request && err.request.actionType !== 'CWARS_GET_LAST_ROUND_RESULTS') {
    dispatch({
      type: SET_ERROR,
      payload: {
        error: err
      }
    });
  } else {
    dispatch({
      type: SET_ERROR,
      payload: {
        error: err
      }
    });
  }
};

export type CHECK_FROM_PARAM_TYPE = "CHECK_FROM_PARAM";
export const CHECK_FROM_PARAM: CHECK_FROM_PARAM_TYPE = 'CHECK_FROM_PARAM';
export const checkFromParam = () => (dispatch: Dispatch, getState: GetState) => {
  const searchParams = searchToObject();

  const isFromPort = (searchParams && searchParams.source === 'port') ? true : false;

  dispatch({
    type: CHECK_FROM_PARAM,
    payload: {
      isFromPort: isFromPort
    }
  });

  if (isFromPort) {
    setTimeout(() => {
      dispatch({
        type: CHECK_FROM_PARAM,
        payload: {
          isFromPort: false
        }
      });
    }, 3000);
  }
};

export type CHECK_READY_TYPE = "CHECK_READY";
export const CHECK_READY: CHECK_READY_TYPE = 'CHECK_READY';
export const checkReady = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const canSetReady = !state.ReducerClanWars.isReady && state.ReducerClanWars.commonInfoReady && state.ReducerClanWars.stageReady && state.ReducerClanWars.warSettingsReady && state.ReducerClanWars.shipsLoaded; //&&
  // state.ReducerClanWars.lastRoundResultsReady

  if (canSetReady) {
    dispatch({
      type: CHECK_READY,
      payload: {
        isReady: true
      }
    });
    dispatch(stopFetching());
  } else {
    setTimeout(() => {
      dispatch(checkReady());
    }, 300);
  }
};


export type SET_WSS_DATA_TYPE = CWARS_UPDATE_COMMON_INFO_TYPE | CWARS_UPDATE_STAGES_TYPE | CWARS_UPDATE_SETTINGS_TYPE | CWARS_UPDATE_RATINGS_TYPE | CWARS_UPDATE_RATINGS_SEARCH_TYPE | CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE_TYPE | CWARS_UPDATE_LAST_ROUND_RESULTS_TYPE | CWARS_UPDATE_ROUNDS_RESULTS_HISTORY_TYPE;
export const setWssData = (type: SET_WSS_DATA_TYPE, payload: any) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: type,
    payload: payload
  });
};


export type SET_USE_ATTEMPTS_TYPE = "SET_USE_ATTEMPTS";
export const SET_USE_ATTEMPTS: SET_USE_ATTEMPTS_TYPE = 'SET_USE_ATTEMPTS';
export const setUseAttempts = (isAttemptsCount: boolean) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  sendCountingCWarsAttempts(state.currentAccount.id, isAttemptsCount);
  WssService.toggleAttemtsCount(isAttemptsCount);
};

export type SET_ONLINE_TYPE = "SET_ONLINE";
export const SET_ONLINE: SET_ONLINE_TYPE = 'SET_ONLINE';
export const setOnline = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_ONLINE
  });
};

export type SET_OFFLINE_TYPE = "SET_OFFLINE";
export const SET_OFFLINE: SET_OFFLINE_TYPE = 'SET_OFFLINE';
export const setOffline = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_OFFLINE
  });
};

export type SET_SELECTED_TAB_TYPE = "SET_SELECTED_TAB";
export const SET_SELECTED_TAB: SET_SELECTED_TAB_TYPE = 'SET_SELECTED_TAB';
export const setSelectedTab = (selectedTab: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_SELECTED_TAB,
    payload: {
      selectedTab: selectedTab
    }
  });
};

export type SET_PREPARE_STAGE_TAB_TYPE = "SET_PREPARE_STAGE_TAB";
export const SET_PREPARE_STAGE_TAB: SET_PREPARE_STAGE_TAB_TYPE = 'SET_PREPARE_STAGE_TAB';
export const setPrepareStageTab = (prepageStageTabIndex: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_PREPARE_STAGE_TAB,
    payload: {
      prepageStageTabIndex: prepageStageTabIndex
    }
  });
};


export type SHOW_STAT_MODAL_TYPE = "SHOW_STAT_MODAL";
export const SHOW_STAT_MODAL: SHOW_STAT_MODAL_TYPE = 'SHOW_STAT_MODAL';
export const showStatModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_STAT_MODAL
  });
};

export type HIDE_STAT_MODAL_TYPE = "HIDE_STAT_MODAL";
export const HIDE_STAT_MODAL: HIDE_STAT_MODAL_TYPE = 'HIDE_STAT_MODAL';
export const hideStatModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_STAT_MODAL
  });
};

export type SHOW_ATTEMPTS_MODAL_TYPE = "SHOW_ATTEMPTS_MODAL";
export const SHOW_ATTEMPTS_MODAL: SHOW_ATTEMPTS_MODAL_TYPE = 'SHOW_ATTEMPTS_MODAL';
export const showAttemptsModal = (id: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_ATTEMPTS_MODAL,
    payload: {
      id
    }
  });
};

export type HIDE_ATTEMPTS_MODAL_TYPE = "HIDE_ATTEMPTS_MODAL";
export const HIDE_ATTEMPTS_MODAL: HIDE_ATTEMPTS_MODAL_TYPE = 'HIDE_ATTEMPTS_MODAL';
export const hideAttemptsModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_ATTEMPTS_MODAL
  });
};

export type SHOW_CALENDAR_MODAL_TYPE = "SHOW_CALENDAR_MODAL";
export const SHOW_CALENDAR_MODAL: SHOW_CALENDAR_MODAL_TYPE = 'SHOW_CALENDAR_MODAL';
export const showCalendarModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_CALENDAR_MODAL
  });
};

export type HIDE_CALENDAR_MODAL_TYPE = "HIDE_CALENDAR_MODAL";
export const HIDE_CALENDAR_MODAL: HIDE_CALENDAR_MODAL_TYPE = 'HIDE_CALENDAR_MODAL';
export const hideCalendarModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_CALENDAR_MODAL
  });
};

export type TOGGLE_AUTO_PARTICIPATION_TYPE = "TOGGLE_AUTO_PARTICIPATION";
export const TOGGLE_AUTO_PARTICIPATION: TOGGLE_AUTO_PARTICIPATION_TYPE = 'TOGGLE_AUTO_PARTICIPATION';
export const toggleAutoParticipation = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const joinRoundAutomatically = state.ReducerClanWars.commonInfo.clan.settings.joinRoundAutomatically;

  WssService.changeJoinRoundAutomatically(!joinRoundAutomatically);
};

export type SET_IS_PARTICIPANT_TYPE = "SET_IS_PARTICIPANT";
export const SET_IS_PARTICIPANT: SET_IS_PARTICIPANT_TYPE = 'SET_IS_PARTICIPANT';
export const setIsParticipant = (value: boolean) => (dispatch: Dispatch, getState: GetState) => {
  WssService.changeIsParticipating(value);
  WssService.getStagesInfo();
};

export type SHOW_NATION_SHIP_TYPE_STATISTIC_TYPE = "SHOW_NATION_SHIP_TYPE_STATISTIC";
export const SHOW_NATION_SHIP_TYPE_STATISTIC: SHOW_NATION_SHIP_TYPE_STATISTIC_TYPE = 'SHOW_NATION_SHIP_TYPE_STATISTIC';
export const showNationShipTypeStatistic = (nation: string, type: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_NATION_SHIP_TYPE_STATISTIC,
    payload: {
      nation,
      type
    }
  });
};

export type TOGGLE_PLAYERS_COUNT_IN_RATING_TYPE = "TOGGLE_PLAYERS_COUNT_IN_RATING";
export const TOGGLE_PLAYERS_COUNT_IN_RATING: TOGGLE_PLAYERS_COUNT_IN_RATING_TYPE = 'TOGGLE_PLAYERS_COUNT_IN_RATING';

export const togglePlayersCountInRating = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: TOGGLE_PLAYERS_COUNT_IN_RATING
  });
};

export type SELECT_RATING_LEAGUE_TYPE = "SELECT_RATING_LEAGUE";
export const SELECT_RATING_LEAGUE: SELECT_RATING_LEAGUE_TYPE = 'SELECT_RATING_LEAGUE';
export const selectRatingLeague = (league?: number) => (dispatch: Dispatch, getState: GetState) => {
  let dispatchObject = null;
  if (league) {
    dispatch({
      type: SELECT_RATING_LEAGUE,
      payload: {
        league
      }
    });
  } else {
    dispatch({
      type: SELECT_RATING_LEAGUE,
      payload: {}
    });
  }

  dispatch(clearSearch());
};

export type SEARCH_INPUT_CHANGE_TYPE = "SEARCH_INPUT_CHANGE";
export const SEARCH_INPUT_CHANGE: SEARCH_INPUT_CHANGE_TYPE = 'SEARCH_INPUT_CHANGE';
export const searchInputChange = (value: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SEARCH_INPUT_CHANGE,
    payload: {
      value
    }
  });
  dispatch(ratingsAutocomplete(value));
};


export type GET_RATINGS_TYPE = "GET_RATINGS";
export const GET_RATINGS: GET_RATINGS_TYPE = 'GET_RATINGS';
export const getRatings = (clanId?: number, league?: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const league = state.ReducerClanWars.selectedClanRatingLeague;
  dispatch({
    type: GET_RATINGS
  });
  WssService.getRatings(clanId, league);
  dispatch(setSelectedClanId(clanId));
};

export type SET_SELECTED_CLAN_ID_TYPE = "SET_SELECTED_CLAN_ID";
export const SET_SELECTED_CLAN_ID: SET_SELECTED_CLAN_ID_TYPE = 'SET_SELECTED_CLAN_ID';
export const setSelectedClanId = (clanId?: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_SELECTED_CLAN_ID,
    payload: {
      clanId: clanId
    }
  });
};

const debouncedAutocomplete = debounce(q => {
  WssService.ratingsAutocomplete(q);
}, 500);

export type RATINGS_AUTOCOMPLETE_TYPE = "RATINGS_AUTOCOMPLETE";
export const RATINGS_AUTOCOMPLETE: RATINGS_AUTOCOMPLETE_TYPE = 'RATINGS_AUTOCOMPLETE';
export const ratingsAutocomplete = (query: string) => (dispatch: Dispatch, getState: GetState) => {
  if (query && query.length >= 2) {
    dispatch({
      type: RATINGS_AUTOCOMPLETE
    });
    debouncedAutocomplete(query);
  }
};

export type RATINGS_SEARCH_TYPE = "RATINGS_SEARCH";
export const RATINGS_SEARCH: RATINGS_SEARCH_TYPE = 'RATINGS_SEARCH';
export const ratingsSearch = (query: string, offset?: number, limit?: number) => (dispatch: Dispatch, getState: GetState) => {
  if (query && query.length > 1) {
    dispatch({
      type: RATINGS_SEARCH
    });
    WssService.ratingsSearch(query, offset ? offset : 0, limit ? limit : 50);
  }
};

export type CLEAR_SEARCH_TYPE = "CLEAR_SEARCH";
export const CLEAR_SEARCH: CLEAR_SEARCH_TYPE = 'CLEAR_SEARCH';
export const clearSearch = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: CLEAR_SEARCH
  });
  dispatch(getRatings());
};

export type SHOW_OWN_CLAN_POSITION_TYPE = "SHOW_OWN_CLAN_POSITION";
export const SHOW_OWN_CLAN_POSITION: SHOW_OWN_CLAN_POSITION_TYPE = 'SHOW_OWN_CLAN_POSITION';
export const showOwnClanPosition = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const clanId = (state.currentAccount && state.currentAccount.clanId) ? state.currentAccount.clanId : null;
  if (clanId) {
    dispatch(getRatings(clanId));
  }
};

export type SHOW_SEASON_LEADERS_TYPE = "SHOW_SEASON_LEADERS";
export const SHOW_SEASON_LEADERS: SHOW_SEASON_LEADERS_TYPE = 'SHOW_SEASON_LEADERS';
export const showSeasonLeaders = () => (dispatch: Dispatch, getState: GetState) => {
  WssService.getRatingLeaders();
};

export type HIDE_LAST_ROUND_RESULT_TYPE = "HIDE_LAST_ROUND_RESULT";
export const HIDE_LAST_ROUND_RESULT: HIDE_LAST_ROUND_RESULT_TYPE = 'HIDE_LAST_ROUND_RESULT';
export const hideLastRoundResults = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const currentRound = get(state, ['ReducerClanWars', 'warSettings', 'currentRound'], 0);

  localStorage.setItem(`clanWarsRound_${currentRound}`, JSON.stringify({ lastRoundResultIsShows: true }));
  dispatch({
    type: HIDE_LAST_ROUND_RESULT
  });
};

export type SHOW_LAST_ROUND_RESULT_TYPE = "SHOW_LAST_ROUND_RESULT";
export const SHOW_LAST_ROUND_RESULT: SHOW_LAST_ROUND_RESULT_TYPE = 'SHOW_LAST_ROUND_RESULT';
export const showLastRoundResults = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_LAST_ROUND_RESULT
  });
};

export type SHOW_HISTORY_MODAL_TYPE = "SHOW_HISTORY_MODAL";
export const SHOW_HISTORY_MODAL: SHOW_HISTORY_MODAL_TYPE = 'SHOW_HISTORY_MODAL';
export const showHistoryModal = () => (dispatch: Dispatch, getState: GetState) => {
  WssService.getRoundsResultsHistory();
  dispatch(setHistoryIsFetching(true));
  dispatch({
    type: SHOW_HISTORY_MODAL
  });
};

export type LOAD_HISTORY_TYPE = "LOAD_HISTORY";
export const LOAD_HISTORY: LOAD_HISTORY_TYPE = 'LOAD_HISTORY';
export const loadHistory = (limit: number = 10, offset: number = 0) => (dispatch: Dispatch, getState: GetState) => {
  WssService.getRoundsResultsHistory(limit, offset);
  dispatch(setHistoryIsFetching(true));
};

export type HIDE_HISTORY_MODAL_TYPE = "HIDE_HISTORY_MODAL";
export const HIDE_HISTORY_MODAL: HIDE_HISTORY_MODAL_TYPE = 'HIDE_HISTORY_MODAL';
export const hideHistoryModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_HISTORY_MODAL
  });
};

export const refreshHistoryModal = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch(setHistoryIsFetching(true));
  WssService.getRoundsResultsHistory();
};

export type SET_HISTORY_IS_FETCHING_TYPE = "SET_HISTORY_IS_FETCHING";
export const SET_HISTORY_IS_FETCHING: SET_HISTORY_IS_FETCHING_TYPE = 'SET_HISTORY_IS_FETCHING';
export const setHistoryIsFetching = (isFetching: boolean) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_HISTORY_IS_FETCHING,
    payload: {
      isFetching
    }
  });
};